import HelpIcon from "@redotech/redo-icons/help-circle.svg";
import classNames from "classnames";
import { memo } from "react";
import { Flex } from "../../flex";
import { Tooltip } from "../../tooltip/tooltip";
import * as baseRedoInputCss from "./base-redo-input.module.css";
import {
  RedoInputSize,
  RedoInputState,
  sizeStyles,
} from "./base-redo-text-input";

export const BaseRedoInputInfoTooltip = memo(function BaseRedoInputInfoTooltip({
  infoTooltip,
  state,
  size,
}: {
  infoTooltip: string;
  state: RedoInputState;
  size: RedoInputSize;
}) {
  const error = state === "error";

  return (
    <Tooltip title={infoTooltip}>
      <Flex
        className={classNames(
          sizeStyles[size],
          baseRedoInputCss.infoIconWrapper,
          error && baseRedoInputCss.error,
        )}
        textColor={error ? "error" : "quaternary"}
      >
        <HelpIcon />
      </Flex>
    </Tooltip>
  );
});
